export const MEETING_CODE_MIN_LENGTH = 9;
export const MEETING_CODE_MAX_LENGTH = 11;

// nick 最大长度 英文字符
export const NICKNAME_MIN_LENGTH = 0;
export const NICKNAME_MAX_LENGTH = 36;
